import React from "react";
import {ValorS, CustomInput} from "./styles";
import {colors, Flex} from "../../ui";
import {animated} from "react-spring";
import {Collapse} from "@material-ui/core";
// import FacturaComp from "./index";
import Cleave from 'cleave.js/react';


export const ValorC = ({
                           onClick,
                           value,
                           nameValue,
                           currency,
                           flex,
                           active,
                           currencySymbol = "$",
                           onChange,
                           placeholder,
                           input,
                       }) => {
    return (
        <ValorS
            flex={flex}
            selected={active ? colors.btn : "transparent"}
            active={active}
        >
            <div className={"listenClick"} onClick={() => onClick ? onClick() : null}>
                <div className={"circle"}>
                    <div className={"point"}></div>
                </div>
                {input ?
                    <div className={"text"}>
                        <b className={"wc d-block"}>{nameValue}</b>
                        <Cleave
                            type={"tel"}
                            value={value}
                            placeholder={placeholder}
                            options={{
                                numeral: true,
                                numeralDecimalMark: '.',
                                delimiter: ',',
                                prefix: '$',
                                signBeforePrefix: true,
                                rawValueTrimPrefix: true,
                                noImmediatePrefix: true
                            }}
                            onChange={e => {
                                onChange(e.target.rawValue)
                            }}
                        />
                    </div>
                    :
                    <div className={"text"}>
                        <b className={"wc d-block"}>{nameValue}</b>
                        {currencySymbol}{value} {currency}
                    </div>
                }
            </div>
        </ValorS>
    )
};

export const ValoresArr = ({arr = [], styles, change, currencySymbol = "$"}) => {
    return (
        <animated.div style={styles} className={"width-100"}>
            <Flex className="wc f01">
                {arr.map((item, index) =>
                    <ValorC
                        key={index}
                        nameValue={item.nameValue}
                        value={item.value}
                        currency={item.active}
                        flex={"1 0 150px"}
                        active={item.active}
                        onClick={item.onClick}
                        currencySymbol={currencySymbol}
                    />
                )}
            </Flex>
        </animated.div>
    )
};

export const CustomValue = ({styles, onChange, value, min, max, tipoModificacion, position, currency = " COP"}) => {
    return (
        <animated.div style={styles} className={"width-100"}>
            <Flex className={"p-1 min-height-63"} jc={"flex-start"}>
                <CustomInput
                    type={"text"}
                    flex={"1 0 150px"}
                >
                    <Cleave
                        value={value}
                        options={{
                            numeral: true,
                            prefix: '$',
                            signBeforePrefix: true
                        }}
                        onChange={e => {
                            onChange(e.target.rawValue)
                        }}
                    />
                </CustomInput>
                <Flex elastic={"0 0 200px"} className={"p-2 px-sm-3"} jc={"flex-start"}>
                    <small>
                        {
                            tipoModificacion === "!="
                                ? `Recuerde que el valor debe ser mayor a $0`
                                : (
                                    tipoModificacion === ">"
                                        ? `Recuerde que el valor debe ser menor o igual a $${max} y mayor o igual a $${min > 0 ? min : 1}`
                                        : 
                                        tipoModificacion == "<>" ? 
                                            `Recuerde que el valor debe ser menor o igual a $${max} y mayor o igual a $${min > 0 ? min : 1}`
                                        :
                                        `Recuerde que el valor debe ser menor o igual a $${max}`
                                )
                        }
                    </small>
                </Flex>
                <div className="wc">
                    <Collapse
                        in={max > 0 ? (value < (min <= 0 ? 1 : min) || value > max) : (value < (min <= 0 ? 1 : min))}>
                        <small className={"text-alert-error"}>El valor no es permitido.</small>
                    </Collapse>
                </div>
            </Flex>
        </animated.div>
    )
};



